module.exports = __webpack_public_path__ + "images/category_lp/macbook/store_images/1_35a4a45914596ad14b1291732a4c3655.png";